import { OkrObjective, OkrKeyResult } from "server/models"

export interface OkrKeyResultProps {
    sessionId: number
    objectiveId: number
    keyResultId: number
}
export interface OkrKeyResultObjectProps {
    objective?: OkrObjective
    keyResult: OkrKeyResult
}


export interface OkrKeyResultList { [keyResultId: number]: OkrKeyResult }
export interface OkrKeyResultIds { [objectiveId: number]: readonly number[] }
export type OkrKeyResultValidation = { [key in keyof OkrKeyResult]?: string}

export interface OkrKeyResultState {
    keyResultList: OkrKeyResultList
    keyResultIds: OkrKeyResultIds
    keyResultEdit: OkrKeyResult

    // to select parent key result
    keyResultListEdit: OkrKeyResultList
    keyResultIdsEdit: readonly number[]

    // popup menu
    active: OkrKeyResult
    menuShow: boolean
    menuTarget: any

    showConfirmDelete: boolean

    reloadEdit: boolean
}

export const OKR_KEY_RESULT_LIST = "OKR_KEY_RESULT_LIST"
export const OKR_KEY_RESULT_IDS = "OKR_KEY_RESULT_IDS"
export const OKR_KEY_RESULT_EDIT = "OKR_KEY_RESULT_EDIT"

// to select parent key result
export const OKR_KEY_RESULT_LIST_EDIT = "OKR_KEY_RESULT_LIST_EDIT"
export const OKR_KEY_RESULT_IDS_EDIT = "OKR_KEY_RESULT_IDS_EDIT"

// popup menu
export const OKR_KEY_RESULT_ACTIVE = "OKR_KEY_RESULT_ACTIVE"
export const OKR_KEY_RESULT_POPUP_MENU_SHOW = "OKR_KEY_RESULT_POPUP_MENU_SHOW"
export const OKR_KEY_RESULT_POPUP_MENU_TARGET = "OKR_KEY_RESULT_POPUP_MENU_TARGET"
export const OKR_KEY_RESULT_SHOW_CONFIRM_DELETE = "OKR_KEY_RESULT_SHOW_CONFIRM_DELETE"

export const OKR_KEY_RESULT_RELOAD_EDIT = "OKR_KEY_RESULT_RELOAD_EDIT"
